import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BrowserApiSupportService } from '@lentau/ui-kit/core/services/browser-api-support/browser-api-support.service';
import { NAVIGATOR } from '@lentau/ui-kit/core/tokens/navigator';
import { GrowthBookService } from '@lentau/core/growth-book/shared';
import { GBFeature } from '@lentau/core/growth-book/shared/interfaces';
import { filter } from 'rxjs';

/**
 * Сервис для управления кэшем статических ресурсов (NGSW) через GrowthBook
 *
 * Получает флаг включения/выключения кэширования статики из GrowthBook
 * и передает его в Service Worker для управления NGSW кэшированием
 */
@Injectable({
  providedIn: 'root',
})
export class StaticCacheManager {
  private browserApi: BrowserApiSupportService = inject(BrowserApiSupportService);
  private growthBookService: GrowthBookService = inject(GrowthBookService);
  private navigator: Navigator = inject(NAVIGATOR);
  private destroyRef: DestroyRef = inject(DestroyRef);

  private readonly FEATURE_KEY: string = 'web.config.static_cache_enabled';

  public subscribeToExperimentResult(): void {
    if (this.browserApi.isServerOrSearchBot()) {
      return;
    }

    this.growthBookService.isInitialized$.pipe(takeUntilDestroyed(this.destroyRef), filter(Boolean)).subscribe(() => {
      const staticCacheEnabled: GBFeature<boolean> = this.growthBookService.getFeatureValue(this.FEATURE_KEY);
      this.updateServiceWorkerCache(staticCacheEnabled.value ?? true);
    });
  }

  public clearStaticCache(): void {
    if ('serviceWorker' in this.navigator && this.navigator.serviceWorker.controller) {
      this.navigator.serviceWorker.controller.postMessage({
        type: 'CLEAR_STATIC_CACHE',
      });
    }
  }

  private updateServiceWorkerCache(enabled: boolean): void {
    if ('serviceWorker' in this.navigator && this.navigator.serviceWorker.controller) {
      this.navigator.serviceWorker.controller.postMessage({
        type: 'SET_STATIC_CACHE_ENABLED',
        enabled: enabled,
      });
    }
  }
}
